import React from 'react';
import _ from 'lodash';
import Select from 'react-virtualized-select';
// import { difference } from 'lodash';
// import 'react-select/dist/react-select.css'
// import 'react-virtualized/styles.css'
// import 'react-virtualized-select/styles.css'

import {
  FormGroup,
  ControlLabel,
  Col
} from 'react-bootstrap';


export const optsBoolean = [
  { value: '0', label: '否' },
  { value: '1', label: '是' }
];


export function optsGenerator(arr) {
  if (!arr) return [];
  let opts = arr.map((item, ind) => {
    return { value: item.id, label: item.name }
  });
  return opts;
}

export function optsGeneratorCommon(arrObj, arrOutputKeys, arrInputKeys, getAllKeys) {
  if (!arrObj) return [];

  const opts = arrObj.map((item, ind) => {

    const len = arrOutputKeys.length;
    let obj;

    if (getAllKeys) {
      obj = item;

      for (let i = 0; i < len; i++) {
        if (arrOutputKeys[i] === arrInputKeys[i]) continue;

        obj[arrOutputKeys[i]] = item[arrInputKeys[i]];
      }
    } else {
      obj = {};

      for (let i = 0; i < len; i++) {
        obj[arrOutputKeys[i]] = item[arrInputKeys[i]];
      }
    }

    return obj;
  });

  return opts;
}

function filterOptions(optsObjArr, stringFilter, selectedOptions) {
  const vaildOptions = _.difference(optsObjArr, selectedOptions);
  // 轉小寫的選項arr應該以state存起來避免每次重運算，只在opts更新時做更新
  // 如果運算loading相對小，不儲存可以節省記憶體，依情境取捨
  let filteredOptsObjArr = [];
  if (stringFilter) {
    let stringFilterLowerCase = stringFilter.toLowerCase();

    _.forEach(vaildOptions, (val, key) => {
      if (
        (
          val.name &&
          val.name.toLowerCase().indexOf(stringFilterLowerCase) !== -1
        ) ||
        (
          val.label &&
          val.label.toLowerCase().indexOf(stringFilterLowerCase) !== -1
        )
      ) {
        filteredOptsObjArr.push(val);
      }
    });
  } else {
    filteredOptsObjArr = vaildOptions;
  }

  return filteredOptsObjArr;
}

const DropDownMenu = props => (
  <Col sm={props.sm}>
    <FormGroup validationState={props.validationState}>
      <ControlLabel style={props.labelStyle}>{props.required ? <span style={{ color: "red" }}>* </span> : ""}{props.label}</ControlLabel>
      <div className={"validation-state-" + props.validationState}>
        <Select
          onValueClick={props.onValueClick}
          multi={props.multi}
          filterOptions={filterOptions}
          openOnFocus={true}
          inputProps={{ id: props.id }}
          disabled={props.disabled}
          valueKey={props.valueKey}
          labelKey={props.labelKey}
          value={props.value}
          matchProp={props.matchProp || "label"}
          clearable={false}
          placeholder={props.optsOnLoading ? "Options on loading…" : (props.placeholder || "Search here")}
          noResultsText={props.noResultsText || "No results found"}
          onChange={selection => { props.onChange(selection, props.stateName); }}
          options={props.options} />
      </div>
    </FormGroup>
  </Col>
);

export default DropDownMenu;


// WEBPACK FOOTER //
// ./src/commonComponents/DropDownMenu.jsx